/** 急诊室 - ICU */

/** 对应的标题 */
const categoryMap = {
  Ramsay: 'Ramsay镇静评分',
  Rudkin: 'Rudkin 镇静评分',
  SAS: '镇静-躁动评分',
  RASS: 'RASS镇静躁动评分',
  ROSIER: 'ROSIER 分级',
  Rockall: 'Rockall 评分',
  ASA: 'ASA 分级',
  OttawaSAH: 'Ottawa SAH 规则',
  NIH: 'NIH 脑卒中量表',
  CormackLehane: 'Cormack 分级',
  FluidRepletionAfterBurns: '烧伤液体复苏'
}
/** 对应的描述 */
const categoryDescMap = {
  Ramsay: '用于ICU监测镇静水平',
  Rudkin: '用于监测镇静程度',
  SAS: '用于ICU检测镇静度',
  RASS: 'Richmond镇静和激动的结构化评估。',
  ROSIER: '急诊室发现脑卒中',
  Rockall: '上消化道出血风险评估',
  ASA: '术前风险评估',
  OttawaSAH: '排除蛛网膜下腔出血',
  NIH: '脑卒中后详细的伤残程度评估',
  CormackLehane: '直接喉镜下插管难度',
  FluidRepletionAfterBurns: 'Parkland 公式'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/ER.js